import "./InfoBanner.scss";
import { useTranslation } from "@me8eon/translation";
import { EonUiIcon } from "@eon-ui/eon-ui-components-react";

type InfoBannerProps = {
    background?: string;
    heading?: string;
    color?: string;
    multiLangHeading?: string;
    icon?: string;
};

export default function InfoBanner({
    background,
    heading,
    multiLangHeading,
    color,
    icon,
}: InfoBannerProps) {
    const t = useTranslation();
    return (
        <div
            data-testid="infoBannerRootId"
            className="banner-wrapper"
            style={{ background }}
        >
            <div className="banner-heading" style={{ color }}>
                {icon && (
                    <EonUiIcon
                        className="eon-ui-svg-icon"
                        data-testid="infoBannerIconId"
                        size="normal"
                        name={icon}
                    />
                )}
                {multiLangHeading ? t(multiLangHeading) : heading}
            </div>
        </div>
    );
}
